import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import useIntersectionObserver from 'helpers/hooks/useIntersectionObserver';

const InView = ({children}) => {
  const ref = useRef(null);
  const entry = useIntersectionObserver(ref, {freezeOnceVisible: true});

  return (
    <div ref={ref}>
      {entry?.isIntersecting ? children : <div style={{height: '50vh'}}/>}
    </div>
  );
};

InView.propTypes = {
  children: PropTypes.node.isRequired
};

export default InView;
